import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { KibouorHomes } from "./components/KibouorHomes";
import { Stories } from "./components/Stories";
import { ImpactDashboard } from "./components/ImpactDashboard";
import { GetInvolved } from "./components/GetInvolved";
import { JoinMovement } from "./components/JoinMovement";
import { Footer } from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import FoundationRegistration from "./pages/FoundationRegistration";
import BlockchainProof from "./pages/BlockchainProof";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <KibouorHomes />
      <Stories />
      <ImpactDashboard />
      <GetInvolved />
      <JoinMovement />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/registration" element={<FoundationRegistration />} />
          <Route path="/blockchain" element={<BlockchainProof />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
